import { render, staticRenderFns } from "./tasks-buying.vue?vue&type=template&id=67caf0de&"
import script from "./tasks-buying.vue?vue&type=script&lang=js&"
export * from "./tasks-buying.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports